var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.isShow)?_c('div',[_c('div',{staticClass:"loader"},[_vm._v("Loading...")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }